<template>
  <v-main class="pa-0" align-content="center">
    <div class="mx-10">ドラッグで並び替え、下の保存ボタンを押してください</div>
    <div class="mx-10">フォルダの中の{{ $t('Lid') }}については並び替えを行いたい場合、フォルダを一度削除して並び替えた上で再度フォルダを作成してください</div>
    <v-card v-if="wss&&wss.length">
      <v-tabs
        v-model="tab"
        align-with-title
        @change="setMylid"
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab
          v-for="ws in wss"
          :key="'folder'+ws.id"
        >
          {{ ws.title }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="ws in wss"
          :key="'folder'+ws.id"
        >
        <v-card class="pa-4">
          <draggable v-model="mylid" draggable=".item">
            <div v-for="item in mylid" :key="item.id" class="item">
              <!-- フォルダや非公開Lidの旨を分かりやすくしたい -->
              <v-card
                elevation="13"
                rounded
                height="50px"
                color="#cce8ff"
                class="mb-2 mx-5"
                ><v-card-text>{{ item.title }}</v-card-text></v-card
              >
            </div>
          </draggable>

          <div class="d-flex mx-4">
            <v-btn
              rounded
              color="#008CFF"
              class="white--text my-5 ml-auto"
              @click="savelid(ws)"
            >
              並び順を保存
            </v-btn>            
          </div>
        </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-card v-else class="pa-4">
      <draggable v-model="mylid" draggable=".item">
        <div v-for="item in mylid" :key="item.id" class="item">
          <!-- フォルダや非公開Lidの旨を分かりやすくしたい -->
          <v-card
            elevation="13"
            rounded
            height="50px"
            color="#cce8ff"
            class="mb-2 mx-5"
            ><v-card-text>{{ item.title }}</v-card-text></v-card
          >
        </div>
      </draggable>
      <div class="d-flex mx-4">
        <v-btn
          rounded
          color="#008CFF"
          class="white--text my-5 ml-auto"
          @click="savelid()"
        >
          並び順を保存
        </v-btn>            
      </div>
    </v-card>
  </v-main>
</template>
  <script>
import draggable from "vuedraggable";
import firebase from "firebase/app";
import "firebase/firestore";
import Vue from 'vue'
import Toasted from "vue-toasted";
Vue.use(Toasted,{iconPack : 'material'})
export default {
  data() {
    return {
      db: firebase.firestore(),
      mylid: [],
      tab: 0,
    };
  },
  created() {
    this.setMylid(this.wss?.length ? 0 : undefined)
  },
  watch: {
    wss: function (val) {
      this.setMylid(val?.length ? 0 : undefined)
    },
  },
  components: {
    draggable: draggable
  },
  computed: {
    navlid() {
      return this.$store.getters.navlid;
    },
    wss() {
      return this.$store.getters.wss;
    },
    numlid() {
      return this.mylid.length;
    },
  },
  methods: {
    setMylid(index=undefined) {
      this.mylid = index==undefined ? this.navlid : this.navlid.filter((e)=>this.wss[index].lids.includes(e.id))
    },
    savelid(ws=null) {
      const self = this;
      const batch = this.db.batch();
      this.mylid.forEach(function (item, index) {
        batch.update(self.db.collection("0").doc(item.id), {
          sort: String(self.numlid - index).padStart(3, "0"),
        });
      });
      batch.commit().then(function () {
        self.$store.dispatch("getLid");
        self.showToast();
      });
    },
    showToast(message="完了しました"){
      this.$toasted.success(message, {
        theme: "bubble",
        position: "top-center",
        duration : 5000,
      });
    },
  },
};
</script>
  